import React from 'react'
import CreativeNameDisplay from '../shared/CreativeNameDisplay'

function TextGalleryPreview({ preview }) {
  let { desc } = preview
  return (
    <div>
      <div className="flex mb-5">
        <div className="items-center">
          <CreativeNameDisplay preview={preview} />
        </div>
      </div>
      <div className="preview-inner overflow-y-auto" style={{ "border-radius": "48px" }}>
        {desc && <>
          {desc.map((item) => {
            if (item.type === "hdl") {
              return <b>{item.value}</b>
            }
            if (item.type === "desc") {
              return <p>{item.value}</p>
            }
            if (item.type === "img") {
              return <img src={item.value} height={item.height} width={item.width} alt="ad" />
            }
            if (item.type === "img-desc") {
              return <i>{item.value}</i>
            }
          })}
        </>}
      </div>
    </div>
  )
}

export default TextGalleryPreview
